/* eslint semi:0 */
import { mountAll } from '../../jsCore/utils/component'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import userToolbarComponent from '../../jsCore/organizedByType/components/userToolbarComponent'
import { registerHamburger } from '../hamburger/hamburger'
import googleSearchComponent from '../../jsCore/organizedByType/components/googleSearchComponent'
import initializeEditionSelection from '../edition_dropdown/editionDropdown'
import { addOnOrientationChangeEvent } from '../../jsCore/utils/window'
import { toggleBemClass, bem, node } from '../../jsCore/utils/dom'
import { SELECTORS } from '../../jsCore/config/preRenderedSelectorsConfig'
import {
  getPlatform,
  getIsDesktop,
  getIsMobileOrTablet,
  getIsIos,
  getIsMobile,
  getIsTablet,
  viewport,
} from '../../jsCore/utils/ua'
import { ads, getPageDomain } from '../../jsCore/application/pageDataObject'
import { adStore } from '../../jsCore/organizedByType/stores/adStore'
import { TYPES } from '../../jsCore/organizedByType/actions/adActions'

const px = num => `${num}px`

let pageWrap = null
let headerNode = null
function getHeaderNode() {
  headerNode = headerNode || node(SELECTORS.SITE_HEADER)
  return headerNode
}
let headerAdNode = null

function initDialogProvider(predicate) {
  if (predicate) {
    require('../../jsCore/providers/dialogProvider')
  }
  return predicate
}

export function mobileHeaderOrientationHandler(vm) {
  addOnOrientationChangeEvent(
    () => {
      repositionMobileHeader(vm)
    },
    () => {
      repositionMobileHeader(vm)
    }
  )
}

export function repositionMobileHeader(vm) {
  // eslint-disable-line complexity
  if (getIsTablet() && viewport.orientation === 'landscape') {
    removeHeaderMargins()
    return this
  }
  if (getIsMobileOrTablet() || getIsIos()) {
    addHeaderMargins(vm)
  }
  return this
}

function removeHeaderMargins() {
  headerAdNode = headerAdNode || node(SELECTORS.HEADER_AD_UNIT)
  if (getIsTablet() || viewport.orientation === 'landscape') {
    getHeaderNode().style.marginTop = px(0)
    const headerHeight = getElementComputedStyleValueOrDefault(getHeaderNode(), 'height')
    headerAdNode.style.marginTop = px(headerHeight)
  } else {
    headerAdNode.classList.remove('isTablet')
  }
  pageWrap = pageWrap || node(SELECTORS.PAGE_WRAP)
  pageWrap.style.marginTop = px(0)
}

function getElementComputedStyleValueOrDefault(element, styleName, defaultValue = 0) {
  return parseFloat(window.getComputedStyle(element)[styleName]) || defaultValue
}

function addHeaderMargins(vm) {
  const TOP_AD_DESKTOP_PADDING = 24
  const MOBILE_HEADER_HEIGHT = 88
  const { mobileHeaderTop } = vm
  const isTablet = getIsTablet()
  let marginTop = mobileHeaderTop === 0 ? 0 : mobileHeaderTop
  const topAdPaddingHeight = isTablet ? TOP_AD_DESKTOP_PADDING : 0

  headerAdNode = headerAdNode || node(SELECTORS.HEADER_AD_UNIT)
  if (!headerAdNode) {
    return
  }
  if (!isTablet || viewport.isPortrait) {
    marginTop = marginTop + topAdPaddingHeight
    headerAdNode.style.marginTop = px(0)
    getHeaderNode().style.marginTop = px(marginTop)
  } else {
    headerAdNode.classList.add('isTablet')
  }
  pageWrap = pageWrap || node(SELECTORS.PAGE_WRAP)
  pageWrap.style.marginTop = px(MOBILE_HEADER_HEIGHT + marginTop)
}

let topSlotHeight

function onTopAdRendered(payload) {
  const { type, size, adId } = payload || {}
  if (type == TYPES.SLOT_RENDERED && adId == 'Top') {
    topSlotHeight = size.height
    attachHeaderRepositionHandlers()
    adStore.removeChangeListener(onTopAdRendered)
  }
}
function attachHeaderRepositionHandlers() {
  const mobileHeaderTop = adStore.state.topSlotHeight || topSlotHeight
  repositionMobileHeader({ mobileHeaderTop }) //should happen after init
  mobileHeaderOrientationHandler({ mobileHeaderTop })
}

export default function mountHeaderComponents() {
  initDialogProvider(!getIsMobileOrTablet())
  registerHamburger()
  initializeEditionSelection()
  mountAll({
    [MOUNT_POINTS.SEARCH_COMPONENT]: googleSearchComponent,
    [MOUNT_POINTS.USER_MENU_DROPDOWN]: userToolbarComponent,
  })
  adStore.addChangeListener(onTopAdRendered)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/headerComponents.js